// src/components/ui/DealershipLogo.jsx
// STATUS: active | UPDATED: 2026-09-01
// LOG:
//   2026-09-01  New. A store's own mark, shown next to ours rather than instead.
//
// logo_path and the dealership-logos bucket have existed since migration 0010
// with nothing uploaded and nothing rendered. This renders it.
//
// THEIR MARK SITS BESIDE OURS, NOT INSTEAD OF IT
//
// This is not a white label. A salesperson is being trained by Janda Dealer
// Training, and hiding that would be dishonest to them and bad for Jazz, whose
// name is the reason the training carries weight. So the sidebar keeps the J|13
// lockup and the store's mark sits under it, quietly, the way a dealership's
// own sign sits under the manufacturer's on a real building.
//
// NEVER INVERTED
//
// Logo.jsx inverts the J|13 mark on dark and says why: it is a single-weight
// neutral lockup with no brand colour, verified by sampling the file. A
// dealership logo is the opposite, full of their colours, and inverting it
// would rotate every hue and hand them a photographic negative of their own
// brand. On dark it gets a soft plate to sit on instead.
//
// A BROKEN LOGO IS WORSE THAN NO LOGO
//
// If the file is missing, deleted or was never a real image, the component
// removes itself rather than leaving a broken-image glyph where somebody's
// business used to be.

import { useState } from 'react'
import { Box, Image } from '@chakra-ui/react'
import { supabase } from '../../lib/supabase'

const BUCKET = 'dealership-logos'

export function dealershipLogoUrl(path) {
  if (!path) return null
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path)
  return data?.publicUrl || null
}

export default function DealershipLogo({ dealership, maxH = '28px', ...props }) {
  const [broken, setBroken] = useState(false)
  const url = dealershipLogoUrl(dealership?.logo_path)
  if (!url || broken) return null

  return (
    <Box
      // A plate on dark so a logo drawn for white paper does not disappear.
      // Nothing on light, where it sits on the card colour it was made for.
      bg={{ base: 'transparent' }}
      _dark={{ bg: 'onInkFill', px: 2, py: 1.5, borderRadius: 'md' }}
      display="inline-flex"
      alignItems="center"
      {...props}
    >
      <Image
        src={url}
        alt={dealership?.name ? `${dealership.name} logo` : 'Dealership logo'}
        maxH={maxH}
        maxW="150px"
        objectFit="contain"
        onError={() => setBroken(true)}
      />
    </Box>
  )
}
